/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentFindOneResponse } from './IncidentFindOneResponse';
import {
    IncidentFindOneResponseFromJSON,
    IncidentFindOneResponseFromJSONTyped,
    IncidentFindOneResponseToJSON,
} from './IncidentFindOneResponse';

/**
 * 
 * @export
 * @interface FindIncidentById200Response
 */
export interface FindIncidentById200Response {
    /**
     * 
     * @type {IncidentFindOneResponse}
     * @memberof FindIncidentById200Response
     */
    data?: IncidentFindOneResponse;
}

/**
 * Check if a given object implements the FindIncidentById200Response interface.
 */
export function instanceOfFindIncidentById200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindIncidentById200ResponseFromJSON(json: any): FindIncidentById200Response {
    return FindIncidentById200ResponseFromJSONTyped(json, false);
}

export function FindIncidentById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindIncidentById200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : IncidentFindOneResponseFromJSON(json['data']),
    };
}

export function FindIncidentById200ResponseToJSON(value?: FindIncidentById200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': IncidentFindOneResponseToJSON(value.data),
    };
}

